<template>
    <b-form @submit.prevent="submitQueryCategory" autocomplete="off">
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label for="name"><strong>Nombre *</strong></label>
                    <b-form-input
                        type="text"
                        id="name"
                        v-model="name">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label for="parent"><strong>Categoría Padre</strong></label>
                    <multiselect
                        id="parent"
                        v-model="parent"
                        :options="queryCategories"
                        track-by="uuid"
                        label="name"
                        :multiple="false"
                        :allowEmpty="true"
                        placeholder="Seleccione opción"
                        selectLabel="+"
                        deselectLabel="-"></multiselect>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="children.length">
            <b-col sm="12">
                <label for="name"><strong>Categorías Hijas</strong></label>
                <div>
                    <b-badge
                        v-for="child in children"
                        :key="child.uuid"
                        pill
                        variant="primary"
                    class="p-2 mr-1">
                        {{ child.name }}
                    </b-badge>
                </div>
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <div class="w-100 d-flex justify-content-between align-items-center m-0 px-3">
                <div>
                    <button
                        type="button"
                        class="btn btn-brand btn-danger btn-lg"
                        v-if="renderDeleteButton"
                        @click="deleteQueryCategory">
                        Eliminar
                    </button>
                </div>
                <div>
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary btn-lg"
                        v-if="renderSaveButton">
                        Guardar
                    </button>
                </div>
            </div>
        </b-row>
    </b-form>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        name: "QueryCategoryForm",
        components: {
            Multiselect
        },
        props: [
            'queryCategory',
            'queryCategories',
            'renderDeleteButton',
            'renderSaveButton'
        ],
        data: function () {
            return {
                name: this.queryCategory.name,
                parent: this.queryCategory.parent,
                children: this.queryCategory.children
            };
        },
        methods: {
            submitQueryCategory() {
                this.$emit('submit-query-category', {
                    name: this.name,
                    parent: this.parent,
                    children: this.children
                });
            },
            deleteQueryCategory() {
                this.$emit('delete-query-category');
            }
        }
    }
</script>